import { Box, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material"
import React from "react"
import AppStickSection from "../../../AppStickSection"
import ValidationHelperText from "../../../common/validation-helper-text"

function MerchantRules({ register, errors }) {
  const merchantRule = [
    "- ارائه یک برگ چک صیادی در وجه شرکت مهندسی نرم‌افزار شقایق به منظور حسن انجام کار ",
    "- دارا بودن سند مالکیت یا سرقفلی",
    "- دارا بودن نماد اعتبار الکترونیک (اینماد) با سابقه فعالیت حداقل یک سال",
    "- امکان ارسال محصولات به کل کشور",
    "- درج قیمت بروز محصولات بر روی سایت فروشگاه",
    "- اعلام و تفکیک کالای موجود و ناموجود",
    "- پشتیبانی و پی‌گیری مشتریان تا زمان تحویل کالا ",
    "- ارسال کالا مطابق با درخواست مشتریان",
    "- تحویل کالا به مشتریان همزمان با پرداخت مبلغ آن سوی مشتریان در خریدهای حضوری",
    "- آغاز فرآیند پردازش تحویل کالا به مشتریان همزمان با پرداخت اینترنتی در خریدهای غیرحضوری ( اینترنتی)"
  ]
  return (
    <Grid
      width={"95%"}
      m='auto'
      sx={{ border: "1px solid #aaa", borderRadius: "0.5rem", padding: "2rem", mt: "2rem", bgcolor: "#F1F1F4" }}
    >
      <AppStickSection title={"قوانین و مقررات درخواست پذیرندگان"} />
      {merchantRule.map((rule, index) => (
        <Typography key={index} variant='body1' color='initial' mt={0.5}>
          {rule}
        </Typography>
      ))}
      <Box ml={2}>
        <FormControlLabel
          sx={{ direction: "rtl" }}
          name='rules'
          {...register("rules", {
            required: {
              value: true,
              message: "پذیرش مقررارت فوق الزامی است"
            }
          })}
          control={<Checkbox />}
          label='مقررات فوق را می پذیرم'
        />
        <ValidationHelperText error={!!errors?.rules} helperText={errors?.rules?.message as string} />{" "}
      </Box>
    </Grid>
  )
}

export default MerchantRules
